import type { FC } from "react";
import { menuStyle } from "./menuStyle.js";

/** Horizontal rule between areas of a menu, such as a header and its options. */
export const MenuSeparator: FC = () => (
  <div className={menuStyle().separator()} />
);
